import config from 'config';
import {
  FETCH_COMPANY_SUCCEEDED,
  UPDATE_COMPANY_SUCCEEDED,
  UPDATE_COMPANY_REQUESTED,
  UPDATE_COMPANY_FAILED,
  UPDATE_MEMBER_SUCCEEDED,
  REMOVE_MEMBERS_SUCCEEDED,
  ADD_CLIENT,
  UPDATE_MEMBER_LIST, UPDATE_CLIENT,
} from './actionTypes';

const initialState = {
  initialInfoFetched: false,
  name: '',
  url: '',
  language: '',
  aiStatus: false,
  image: '',
  editing: false,
  subs: [],
  members: [],
  tariff: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_COMPANY_SUCCEEDED: {
      const { company } = action.payload;

      Object.keys(company).forEach((key) => {
        if (company[key] === null) {
          company[key] = '';
        }
      });

      return Object.assign({}, state, company, { initialInfoFetched: true });
    }
    case UPDATE_COMPANY_REQUESTED:
      return Object.assign({}, state, { editing: true });
    case UPDATE_COMPANY_SUCCEEDED:
      return Object.assign({}, state, action.payload.companyUpdate, { editing: false });
    case UPDATE_COMPANY_FAILED:
      return Object.assign({}, state, { editing: false });
    case UPDATE_MEMBER_SUCCEEDED:
      return Object.assign({}, state, {
        members: state.members.map((member) => {
          if (member.id !== action.payload.memberUpdate.id) {
            return member;
          }
          return Object.assign(member, action.payload.memberUpdate);
        }),
      });
    case REMOVE_MEMBERS_SUCCEEDED: {
      const removedMembersIdList = action.payload.membersList.map(member => member.id);
      return Object.assign({}, state, {
        members: state.members.filter(member => removedMembersIdList.indexOf(member.id) === -1),
      });
    }
    case ADD_CLIENT: {
      return Object.assign({}, state, {
        subs: state.subs.concat(action.payload.client),
      });
    }
    case UPDATE_MEMBER_LIST: {
      const { membersUpdate } = action.payload;
      return Object.assign({}, state, {
        members: state.members.map((member) => {
          const updatedData = membersUpdate.find(memberUpdate => memberUpdate.id === member.id);
          return updatedData ? Object.assign({}, member, updatedData) : member;
        }),
      });
    }
    case UPDATE_CLIENT: {
      const { clientId, update } = action.payload;
      return Object.assign({}, state, {
        subs: state.subs
          .map((sub) => {
            if (sub.id === clientId) {
              return Object.assign(sub, update);
            }
            return sub;
          })
          .filter(sub => sub.status !== config.companyStatusMap.deleted),
      });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/company/reducer.js